var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobileGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8B5CF6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6D28D9",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#F8FAFC",
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 240,
    rx: 15,
    fill: "#FFFFFF",
    stroke: "#E2E8F0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 120,
    height: 220,
    rx: 10,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 100,
    height: 40,
    rx: 8,
    fill: "url(#mobileGradient)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 90,
    width: 100,
    height: 20,
    rx: 4,
    fill: "#FFFFFF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 120,
    width: 100,
    height: 20,
    rx: 4,
    fill: "#FFFFFF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 250,
    r: 15,
    stroke: "#E2E8F0",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160, 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 200,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8F0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 104,
    height: 184,
    rx: 8,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24,
    width: 88,
    height: 35,
    rx: 6,
    fill: "url(#mobileGradient)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 77,
    width: 88,
    height: 17,
    rx: 3,
    fill: "#FFFFFF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 104,
    width: 88,
    height: 17,
    rx: 3,
    fill: "#FFFFFF",
    opacity: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDev);
export default __webpack_public_path__ + "static/media/mobile_dev.9fc0790476ed880477b488f9d1f41496.svg";
export { ForwardRef as ReactComponent };